import React from "react";
import Skeleton from "./Skeleton";
import skeletonStyles from "../../style/skeleton.module.css";

const LegalPageSkeleton = () => (
  <div
    className="container page-shell legal-page pt-3 pt-md-5 pb-4 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading page"
  >
    <Skeleton className={skeletonStyles.skeletonTitle} />
    <Skeleton
      className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort} mt-3`}
    />
    <div className={`${skeletonStyles.skeletonStack} mt-3`}>
      <Skeleton className={skeletonStyles.skeletonParagraph} />
      <Skeleton
        className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
      />
    </div>
    <div className={skeletonStyles.skeletonLegalAccordion}>
      <Skeleton className={skeletonStyles.skeletonLegalItem} />
      <Skeleton className={skeletonStyles.skeletonLegalItem} />
      <Skeleton className={skeletonStyles.skeletonLegalItem} />
      <Skeleton className={skeletonStyles.skeletonLegalItem} />
    </div>
  </div>
);

export default LegalPageSkeleton;
